
import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';

interface LocationFieldsProps {
  departure: string;
  arrival: string;
  onDepartureChange: (value: string) => void;
  onArrivalChange: (value: string) => void;
}

const LocationFields: React.FC<LocationFieldsProps> = ({ 
  departure, 
  arrival, 
  onDepartureChange,
  onArrivalChange
}) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div className="space-y-2">
        <Label htmlFor="departure-location">Departure From</Label>
        <Input 
          id="departure-location" 
          value={departure}
          onChange={(e) => onDepartureChange(e.target.value)}
          placeholder="City or airport"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="arrival-location">Arrival To</Label>
        <Input 
          id="arrival-location" 
          value={arrival}
          onChange={(e) => onArrivalChange(e.target.value)}
          placeholder="City or airport"
        />
      </div>
    </div>
  );
};

export default LocationFields;
